module.exports = __webpack_public_path__ + "img/20200801_130300.2e0c368c.jpg";